import TechniquesEditor from './shared/TechniquesEditor';
import SparringSection from './shared/SparringSection';
import { useToast } from '../../context/ToastContext';
import { numericProps } from '../../utils/numericInput';

export default function GrapplingForm({ form, set, friends, sparRounds, setSparRounds, sparMin, setSparMin }) {
    const showToast = useToast();
    const sp = form._sportConfig;
    return (
        <>
            <div className="form-group">
                <label className="form-label">오늘의 주제</label>
                <input
                    className="form-input"
                    placeholder={sp?.focusPlaceholder || '오늘의 주제'}
                    value={form.focus || ''}
                    onChange={e => set('focus', e.target.value)}
                />
            </div>
            <div className="form-group">
                <label className="form-label">드릴 시간 (분)</label>
                <input
                    className="form-input"
                    placeholder="예: 30 (스파링 전 드릴/기술 연습 시간)"
                    {...numericProps(form.drillTime || '', v => set('drillTime', v), showToast)}
                />
            </div>
            <div className="form-group">
                <label className="form-label">기술 / 드릴 / 포인트</label>
                <TechniquesEditor
                    techniques={form.techniques}
                    onChange={val => set('techniques', val)}
                    showResult={true}
                />
            </div>
            <SparringSection
                form={form}
                set={set}
                friends={friends}
                sparRounds={sparRounds}
                setSparRounds={setSparRounds}
                sparMin={sparMin}
                setSparMin={setSparMin}
            />
        </>
    );
}
